/**
 * 发行平台-藏品权益领取页
 * route:/nftPad/rightsOrder
 * @param targetType 1-针对藏品, 2-针对欧皇徽章
 * @param targetId 关联ID (藏品关联ID或活动ID)
 * @param nftNo 藏品编号
 * @param reqId 唯一id（权益id）
 */
import React, {useEffect, useState, Fragment} from "react";
import {Toast} from "antd-mobile";
import Service from "./service";
import './index.scss';
import NFTHeader from "@/components/NFTHeader";
import {getUrlAllParams} from "@/utils/publicFun";
import {useLocation} from "react-router-dom";
import address_icon from '../images/address_icon.png'
import JsBridgeNew from "@/utils/jsbridgeNew";

const RightsOrder = () => {
  const {search} = useLocation()
  const param = getUrlAllParams(search.slice(1)) // 获取参数
  const {reqId, ...otherParam} = param
  const [visible, setVisible] = useState(false)
  const [addressItem, setAddressItem] = useState()
  const [stateParam, setStateParam] = useState(otherParam)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    queryDefaultAddress()
  }

  const queryDefaultAddress = async () => {
    const item = await Service.queryCommonAddress()
    if (item) {
      setAddressItem(item)
    }
  }

  const onSubmit = async () => {
    if (addressItem.needComplete) {
      return Toast.show('请先完善地址信息');
    }
    try {
      const params = {
        targetType: +param?.targetType,
        targetId: param?.targetId,
        nftNo: +param?.targetType === 1 ? param?.nftNo : null,
        reqId: param?.reqId,
        shippingInfo: {
          province: addressItem.provinceName,
          city: addressItem.cityName,
          area: addressItem.areaName,
          street: addressItem.streetName,
          address: addressItem.deliveryAddress,
          consigneeNumber: addressItem.consigneeNumber,
          consigneeName: addressItem.consigneeName,
        },
      }
      // console.log(params)
      const res = await Service.benefitGet(params)
      if (res.code !== '000000') throw res.msg
      Toast.show({
        content: '提交成功', afterClose: () => {
          window.JsBridge.back()
        }
      })
    } catch (e) {
      Toast.show(e)
      console.log(e)
    }
    onClose()
  }

  const onChangeAddress = async () => {
    if(stateParam.orderId){
      return
    }
    if (window.JsBridge.hasWebViewBridge()) {
      const address = await JsBridgeNew.push('CustomWeb', {
        uri: process.env.REACT_APP_GKT_LINK + `/front/guapp/address/addressList?mode=1`,
        callback: true
      });
      if (address) {
        setAddressItem(address)
      }
    }

    onClose()
  }

  const onConfirmOrder = async () => {
    if (addressItem.needComplete&&(!stateParam.isnoShiwu||stateParam.isnoShiwu === '0')) {
      //完善地址信息
      Toast.show('请先完善地址信息')
    } else {
      setVisible(true)
    }

  }

  const onClose = () => {
    setVisible(false)
  }

  return (
    <div className="activity_order_page">
      <NFTHeader midText={`${stateParam.orderId ? '订单信息' : '确认订单'}`}/>
      <div className="body">
        {/* 地址信息 */}
        <div className="address-item" onClick={onChangeAddress}>
          <img src={address_icon} alt=""/>
          {
            addressItem ?
              <div className="address-center">
                <div className="user_info">
                  <span>{addressItem.consigneeName || ''}</span>
                  <span>{addressItem.consigneeNumber || ''}</span>
                </div>
                <div className="address-info">
                  {addressItem.provinceName + addressItem.cityName + addressItem.areaName + (addressItem.streetName || '') + (addressItem.deliveryAddress || '')}
                </div>
              </div>
              : <div className="none-address">您的收货地址为空，点击添加收货地址</div>

          }
          <div className="right-arrow">
            {!stateParam.orderId && <img src={require('../images/more_icon.png')} alt=""/>}
          </div>
        </div>
        {/* 商品信息 */}
        <div className="shop-item">
          <div className="item_top">
            <div className="left">
              <img src={decodeURI(stateParam.imgUrl)} alt=""/>
            </div>
            <div className="right">
              <span>{decodeURI(stateParam.benefitName || '')}</span>
              {stateParam?.quantity && <div className="right-count">x{stateParam?.quantity}</div>}
            </div>
          </div>
          <div className={'item_bottom'}>
            <div>配送服务</div>
            <span>快递免邮</span>
          </div>
        </div>
      </div>
      {
        stateParam.orderId ? null :
          <div className={`bottom`}>
            {
              addressItem ?
                <div className={`button`} onClick={onConfirmOrder}>{'提交订单'}</div>
                : <div className={`button disable`}>{'提交订单'}</div>
            }

          </div>
      }
      <ConfirmModal visible={visible}
                    onClose={onClose}
                    addressItem={addressItem}
                    onEditAddress={onChangeAddress}
                    onSubmit={onSubmit}
      />
    </div>
  )
}

// 此处弹框和积分商城兑换弹框保持一致
const ConfirmModal = (props) => {
  const {visible, addressItem, onClose} = props
  return (
    <Fragment>
      {
        visible ?
          <div className="confirm_modal_mask">
            <div className="modal_body">
              <div className="modal_header">
                <div className="modal_header_title">核对地址</div>
                <img src={require('../images/icon_close.png')} alt="" onClick={onClose}/>
              </div>
              <div className="modal_content">
                <div className="notice_info">提交后收件人信息不可更改，请您仔细核对收件人信息哦</div>
                <div className="confirm_info">
                  <div>
                    <span>姓名：</span>
                    <span>{addressItem.consigneeName || ''}</span>
                  </div>
                  <div>
                    <span>电话：</span>
                    <span>{addressItem.consigneeNumber || ''}</span>
                  </div>
                  <div>
                    <span>地址：</span>
                    <span>{addressItem.provinceName + addressItem.cityName + addressItem.areaName + (addressItem.streetName || '') + (addressItem.deliveryAddress || '')}</span>
                  </div>
                </div>
              </div>
              <div className="modal_footer">
                <div onClick={props.onEditAddress}>{'修改信息'}</div>
                <div onClick={props.onSubmit}>{'确认'}</div>
              </div>
            </div>
          </div>
          : null
      }
    </Fragment>
  )
}

export default RightsOrder